import { useContext, useState, useEffect } from 'react';
import { AppContext, ApplicationContext } from '../ApplicationContext';
import {MessageList } from "./MessageList";
import { IMessage } from "./Message";
import {
  delay,
  isServiceBusError,
  ProcessErrorArgs,
  ServiceBusClient,
  ServiceBusReceivedMessage,
} from "@azure/service-bus";

//import { PrivacyAndComplianceDefaults } from "./PrivacyAndComplianceMessage";

export interface IMessengerClientProps {

    dialog?:string|null;
    session?:string|null;

}

interface IMessengerSubscription {


    connection: string;
    topic: string;
    subscriptionName: string;
    client:ServiceBusClient;
    receiver: any;
   
    subscription:any;
}



export const MessengerClient =  (props: IMessengerClientProps) => {


    const context = useContext(AppContext);

    const [connected, setConnected] = useState( context.messenger.connected /*context.connection.state === HubConnectionState.Connected*/ );

    const [subscription, setSubscription] = useState<IMessengerSubscription>(null);
    
    const [messages, setMessages] = useState<IMessage[]>([]);

    //console.log("MessengerClient",{messages:messages});

    //Sent a message as the client
    const onSentMessage = (msg: IMessage) => {
    
        //const msg = JSON.parse(body);

        //console.log("onSentMessage", {messages:messages,msg:msg/*, body: body*/});
    
        //appendMessage(msg);
        setMessages( (messages) => [...messages, msg]);
    };

    const onHistory = (msg: IMessage[]) => {
    
         setMessages( (messages) => [...messages, ...msg]);

    }

    context.messenger.onSentMessage = onSentMessage;
    context.messenger.onHistory = onHistory;


    useEffect( ()=> {
        
            //Connect using MessengerController
            context.messenger.connect().then(()=>{
            
               // console.log("Messenger Connect", context);

                setConnected(context.messenger.connected);

                if(context.messenger.connected) {
                    console.log("Privacy and Security",{settings: context.messenger.connection.settings});
                    var txt = (context.messenger.connection.settings.privacyAndComplianceDefaults as any).replaceAll("'","\"");
                    console.log(txt);
                    var pm = (JSON.parse(txt) as IMessage);

                    setMessages([...messages, pm]);

                    onSubscribe(context.messenger.connection.connectionString, context.messenger.connection.topic, context.messenger.connection.subscription);

                }

            
            });
            
            
        },[]);



    const onSubscribe =  (connection:string, topicName:string, subscriptionName:string) => {
        
         //console.log("onSubscribe",  {
//
//   connection: connection,
//   topic:topicName,
//   subscription:subscriptionName});


         let client:ServiceBusClient = new ServiceBusClient(connection);
         let receiver = client.createReceiver(topicName, subscriptionName);

         let subscription = receiver.subscribe({

              // After executing this callback you provide, the receiver will remove the message from the queue if you
              // have not already settled the message in your callback.
              // You can disable this by passing `false` to the `autoCompleteMessages` option in the `subscribe()` method.
              // If your callback _does_ throw an error before the message is settled, then it will be abandoned.
              processMessage: async (brokeredMessage: ServiceBusReceivedMessage) => {
                
                  //console.log("Received message", {messages:messages,brokeredMessage:brokeredMessage});

                  //appendMessage(brokeredMessage.body);
                  setMessages( (messages) => [...messages, brokeredMessage.body]);
              },

              // This callback will be called for any error that occurs when either in the receiver when receiving the message
              // or when executing your `processMessage` callback or when the receiver automatically completes or abandons the message.
              processError: async (args: ProcessErrorArgs) => {
                
                  console.log("Error", args);
                  console.log(`Error from source ${args.errorSource} occurred: `, args.error);

                // the `subscribe() call will not stop trying to receive messages without explicit intervention from you.
                if (isServiceBusError(args.error)) {
                  switch (args.error.code) {
                    case "MessagingEntityDisabled":
                    case "MessagingEntityNotFound":
                    case "UnauthorizedAccess":
                      // It's possible you have a temporary infrastructure change (for instance, the entity being
                      // temporarily disabled). The handler will continue to retry if `close()` is not called on the subscription - it is completely up to you
                      // what is considered fatal for your program.
                      console.log(
                        `An unrecoverable error occurred. Stopping processing. ${args.error.code}`,
                        args.error,
                      );
                      await subscription.close();
                      break;
                    case "MessageLockLost":
                      console.log(`Message lock lost for message`, args.error);
                      break;
                    case "ServiceBusy":
                      // choosing an arbitrary amount of time to wait.
                      await delay(1000);
                      break;
                  }
                }
              },
            });


         let connector: IMessengerSubscription = {
            connection: connection,
            topic:topicName,
            subscriptionName:subscriptionName,
            receiver: receiver,
            client: client,
            subscription: subscription
         }; 

         setSubscription(connector);

         if(props.session && props.dialog){
            context.messenger.startSession(props.dialog, props.session);
         } else if(props.dialog) {
             context.messenger.startDialog(props.dialog);
         }

    };

    

    

    /*
    if(context.connection.state !== HubConnectionState.Connected && context.connection.state !== HubConnectionState.Connecting){
                    
            try {

                context.connection.start().then(()=>{
                    

                    context.connection.onreconnecting(function(){
                        setConnected(false);
                    });

                    context.connection.onreconnected(function(){
                        setConnected(true);
                    });

                    context.connection.on("sentmessage", onSentMessage);
                    context.connection.on("subscribe", onSubscribe);


                    setConnected(context.connection.state === HubConnectionState.Connected);
                    

                    console.log("Connect", { dialog:props.dialog, session: props.session });
                    context.connection.invoke("Connect", props.dialog, props.session);

                    console.log("connected",{connection: context.connection });


                }, (err)=>{
                    console.log({error:err});

                    setConnected(context.connection.state === HubConnectionState.Connected);
                });
               
            
            } catch (err) {
            
                console.log(err);
                setConnected(context.connection.state === (HubConnectionState.Connected as string));

            }


    }
    */
   
    return (  <div className="container-fluid mr-messenger-root">
    <div className="mr-messenger-content">
        { (!connected) && <div className="alert alert-secondary" role="alert">
                            Trying to connect...
        </div> }
        { connected && <MessageList messages={messages}/> }
        </div>
        <div className="mr-message-list-toolbar">&nbsp;</div>
      </div>         
    );

}